export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'amaru.theme';

const isTheme = (value: unknown): value is Theme => value === 'light' || value === 'dark';

/** El tema guardado, o `null` si no hay, no es válido o el storage no se puede leer. */
export function readStoredTheme(): Theme | null {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isTheme(stored) ? stored : null;
  } catch {
    return null;
  }
}

/** Guarda la elección. Si el storage falla (modo privado, cuota, bloqueado) no lanza. */
export function writeStoredTheme(theme: Theme): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Sin persistencia el tema sigue funcionando en la sesión.
  }
}

/** El tema del sistema. Sin `matchMedia` (jsdom, navegadores viejos) se queda en oscuro. */
export function systemTheme(): Theme {
  if (typeof window.matchMedia !== 'function') return 'dark';
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

/**
 * La elección guardada gana; si no hay, el sistema. Se lee una vez al montar: un cambio del
 * sistema con la página abierta no se sigue en vivo.
 */
export function initialTheme(): Theme {
  return readStoredTheme() ?? systemTheme();
}
